import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  selectCurrentCoopData,
  selectCurrentUserData,
} from "../store/auth/index";
import {
  applyTenantIdentity,
  restoreThemeFromStorage,
} from "../theme/companyTheme";

/**
 * Applies cooperative branding from localStorage, getCooperative, and login profile.
 * Components must consume CSS variables only — not company.theme directly.
 */
export default function CompanyThemeProvider({ children }) {
  const coopData = useSelector(selectCurrentCoopData);
  const userData = useSelector(selectCurrentUserData);

  useEffect(() => {
    restoreThemeFromStorage();
  }, []);

  useEffect(() => {
    applyTenantIdentity(coopData, userData?.company);
  }, [coopData, userData?.company]);

  return children;
}
